import request from '@webtrader/core/request';

export interface IAnnouncement {
  announcement: string;
  announcementHeader: string | null;
  publishDate: Date;
  url?: string;
}

const announcements = () => {
  return request.get<IAnnouncement[]>('/api/config/v1/announcement');
};

export default announcements;
